<kendo-appbar position="top">
  <kendo-appbar-section>
    <div class="tabs-container">
      <button
        *ngFor="let tab of tabs; let index = index"
        kendoButton
        (click)="onTabSelect(tab)"
        [fillMode]="selectedTabIndex == index ? 'solid' : 'flat'"
      >
        {{ tab.name }}
      </button>
    </div>
  </kendo-appbar-section>
</kendo-appbar>

<router-outlet></router-outlet>
